export const mainMenu = {
  title: "منوی اصلی",
  menuItems: [
    {
      title: "برنامه ها",
      key: "app",
      path: "/app/list",
      icon: "terminal-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "دیتابیس ها",
      key: "database",
      path: "/database/list",
      icon: "server",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "دامنه ها",
      key: "domain",
      path: "/domain/list",
      icon: "globe",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "پرداخت‌ها",
      key: "payment",
      path: "/payment/list",
      icon: "cash-stack",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "پشتیبان‌گیری",
      key: "backup",
      path: "/backup/list",
      icon: "clock-history",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "تیکت‌ها",
      key: "ticket",
      path: "/ticket/list",
      icon: "chat-left-text-fill",
      subMenuShow: false,
      submenu: []
    }
  ]
};

export const dbMenu = serviceId => ({
  title: "دیتابیس‌ها",
  menuItems: [
    {
      title: "جزئیات دیتابیس",
      key: "info-db",
      path: `/database/${serviceId}/details`,
      icon: "exclamation-circle-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "پشتیبان‌گیری",
      path: `/database/${serviceId}/backup`,
      key: "backup",
      icon: "clock-history",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "تغییر اندازه",
      key: "resize",
      path: `/database/${serviceId}/resize`,
      icon: "exclamation-circle-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "بازگشت",
      path: "/database/list",
      key: "back",
      icon: "box-arrow-in-right",
      subMenuShow: false,
      submenu: []
    }
  ]
});

export const appMenu = serviceId => ({
  title: "برنامه ها",
  menuItems: [
    {
      title: "جزئیات برنامه",
      key: "info-app",
      path: `/app/${serviceId}/details`,
      icon: "exclamation-circle-fill",
      subMenuShow: false,
      submenu: []
    },
    // {
    //   title: "استقرارها",
    //   key: "applets",
    //   path: `/app/${serviceId}/applets`,
    //   icon: "grid1x2-fill",
    //   subMenuShow: false,
    //   submenu: []
    // },
    // {
    //   title: "تاریخچه",
    //   path: `/app/${serviceId}/releases`,
    //   key: "releases",
    //   icon: "clock-history",
    //   subMenuShow: false,
    //   submenu: []
    // },
    {
      title: "وضعیت منابع",
      path: `/app/${serviceId}/monitoring`,
      key: "monitoring",
      icon: "graph-up",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "گزارشات",
      path: `/app/${serviceId}/logs`,
      key: "logs",
      icon: "file-earmark-text-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "راه‌اندازی FTP",
      path: `/app/${serviceId}/ftp`,
      key: "ftp",
      icon: "cloud-plus-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "مدیریت فایل",
      path: `/app/${serviceId}/filemanager`,
      key: "filemanager",
      icon: "folder2-open",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "پشتیبان‌گیری",
      path: `/app/${serviceId}/backup`,
      key: "backup",
      icon: "clock-history",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "ارتقا پلن",
      path: `/app/${serviceId}/resize`,
      key: "resize",
      icon: "cpu-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "تنظیمات",
      path: `/app/${serviceId}/settings`,
      key: "settings",
      icon: "gear-fill",
      subMenuShow: false,
      submenu: []
    },
    {
      title: "بازگشت",
      path: "/app/list",
      key: "back",
      icon: "box-arrow-in-right",
      subMenuShow: false,
      submenu: []
    }
  ]
});
